import React from 'react';
import {Grid} from "@mui/material";
import {StyledInput} from "../../form/input";
import UploadDropzone from "../../form/upload-dropzone";
import {useTranslation} from "react-i18next";

export const AddBookForm: React.FC<Props> = ({form, contentFile, setContentCover, contentCover, setContentFile, fileError}) => {
    const { t } = useTranslation('publisher');

    return (
        <Grid container direction={"row"} spacing={2}>
            <Grid container item sm={12} md={6} direction={"column"} spacing={2}>
                <Grid item>
                    <StyledInput
                        id="title"
                        label={t('addBook.form.title') + " *"}
                        onChange={form.handleChange}
                        value={form.values.title}
                        error={form.errors.title && form.touched.title}
                    />
                </Grid>

                <Grid item>
                    <StyledInput
                        id="isbn"
                        label={t('addBook.form.isbn') + " *"}
                        onChange={form.handleChange}
                        value={form.values.isbn}
                        error={form.errors.isbn && form.touched.isbn}
                    />
                </Grid>

                <Grid item>
                    <StyledInput
                        id="authors"
                        label={t('addBook.form.authors') + " *"}
                        onChange={form.handleChange}
                        value={form.values.authors}
                        error={form.errors.authors && form.touched.authors}
                    />
                </Grid>
            </Grid>

            <Grid container item sm={12} md={6} direction={"column"} spacing={2}>
                <Grid item>
                    <UploadDropzone
                        values={form.values}
                        setFieldValue={form.setFieldValue}
                        fieldName={'fullContent'}
                        inputAccept={'application/pdf,.txt'}
                        description={t('addBook.form.fullContent') + " *"}
                        initialValue={contentFile}
                        setInitialValue={setContentFile}
                        info={t('addBook.form.fullContentInfo')}
                        error={fileError}
                    />
                </Grid>

                <Grid item>
                    <UploadDropzone
                        values={form.values}
                        setFieldValue={form.setFieldValue}
                        fieldName={'cover'}
                        inputAccept={'image/*,application/pdf'}
                        description={t('addBook.form.cover')}
                        initialValue={contentCover}
                        setInitialValue={setContentCover}
                        info={t('addBook.form.coverInfo')}
                        error={false}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

interface Props {
    form: any,
    contentFile?: string,
    setContentFile?: any,
    contentCover?: string,
    setContentCover?: any,
    fileError: boolean
}
